import React from 'react';
import { Sparkle } from './Sparkle';
import { CtaButton } from './CtaButton';
export function Reframe() {
  return <section aria-labelledby="reframe-title" className="bg-ink text-cream" data-id="element-156" data-mp="13ygq1t70k4ny">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center lg:py-28" data-id="element-157" data-mp="1ioxpj7038ki7">
        <Sparkle className="mx-auto h-8 w-8 text-rust" data-id="element-158" data-mp="1iq8s53hsrm7q" />
        <h2 id="reframe-title" className="mt-5 font-display text-[2rem] font-black leading-[1.05] tracking-tight sm:text-6xl" data-id="element-159" data-mp="1dqme4ru5a1xv">
          El problema no eres tú.
          <span className="mt-2 block text-rust" data-id="element-160" data-mp="l0vzmholoy18">El problema es que nadie te enseñó a priorizarte.</span>
        </h2>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-kraft-light" data-id="element-161" data-mp="zy6jaebeda81">
          La buena noticia es que organizarte no es un talento. Es un hábito. Y los hábitos se construyen con el
          método correcto.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-kraft-light" data-id="element-162" data-mp="2bb8qwjviqpg2">
          Con un sistema simple, cualquier persona puede aprender a ponerse primero, dejar de vivir apagando incendios
          y empezar a diseñar su vida de verdad. <strong className="text-cream" data-id="element-163" data-mp="2ruto7tsfee1d">En solo 30 días.</strong>
        </p>
        <div className="mt-10" data-id="element-164" data-mp="2wug285g2vyb8">
          <CtaButton label="¡Sí, quiero empezar ahora!" align="center" tone="light" data-id="element-165" data-mp="2wu6c8hv19r5j" />
        </div>
      </div>
    </section>;
}